import * as React from 'react';

const FigmaColoredIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height="28" viewBox="0 0 19 28" width="19" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="&#240;&#159;&#166;&#134; icon &#34;figma&#34;">
            <g id="Group">
                <path
                    d="M14.1667 18.6668C16.744 18.6668 18.8333 16.5775 18.8333 14.0002C18.8333 11.4228 16.744 9.3335 14.1667 9.3335C11.5893 9.3335 9.5 11.4228 9.5 14.0002C9.5 16.5775 11.5893 18.6668 14.1667 18.6668Z"
                    fill="#19BCFE"
                    id="Vector"
                />
                <path
                    clipRule="evenodd"
                    d="M4.83317 28.0001C7.4105 28.0001 9.49984 25.9107 9.49984 23.3334C9.49984 22.6299 9.49984 21.0743 9.49984 18.6667C7.40338 18.6667 5.84783 18.6667 4.83317 18.6667C2.25584 18.6667 0.166504 20.7561 0.166504 23.3334C0.166504 25.9107 2.25584 28.0001 4.83317 28.0001Z"
                    fill="#09CF83"
                    fillRule="evenodd"
                    id="Vector_2"
                />
                <path
                    clipRule="evenodd"
                    d="M4.83317 18.6668H9.49984V9.3335C7.24784 9.3335 5.69228 9.3335 4.83317 9.3335C2.25584 9.3335 0.166504 11.4228 0.166504 14.0002C0.166504 16.5775 2.25584 18.6668 4.83317 18.6668Z"
                    fill="#A259FF"
                    fillRule="evenodd"
                    id="Vector_3"
                />
                <path
                    clipRule="evenodd"
                    d="M4.83317 9.33333H9.49984V0C7.24784 0 5.69228 0 4.83317 0C2.25584 0 0.166504 2.08934 0.166504 4.66667C0.166504 7.244 2.25584 9.33333 4.83317 9.33333Z"
                    fill="#F24E1E"
                    fillRule="evenodd"
                    id="Vector_4"
                />
                <path
                    clipRule="evenodd"
                    d="M14.1667 9.33333H9.5V0H14.1667C16.744 0 18.8333 2.08934 18.8333 4.66667C18.8333 7.244 16.744 9.33333 14.1667 9.33333Z"
                    fill="#FF7262"
                    fillRule="evenodd"
                    id="Vector_5"
                />
            </g>
        </g>
    </svg>
);
export default FigmaColoredIcon;
